import React, { useEffect } from "react";

import { Link } from "react-router-dom";

import LMS from "./Assets/lms.png";
import EMS from "./Assets/ems.png";
import CCD from "./Assets/ccd.png";

const Products = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [])
  return (
    <>
      <div className="banner ourservices section" id="home">
        <div className="banner-overlay"></div>
        <div className="banner-content">
          <h1>
            Our <span>Products</span>
          </h1>
        </div>
      </div>
      <section className="our_products" id="section11">
        <div className="container-fluid">
          <div className="products-list">
            <div className="row mb-3">
              <div className="col-lg-6">
                <div className="left">
                  <h5>Learning Management System</h5>
                  <p>
                    Fidus LMS offers complete white labeling and customization
                    options, ensuring alignment with employer branding. Every
                    aspect, from features to color schemes to customizable
                    themes, can be tailored to reflect the organization's
                    identity.
                  </p>
                  <Link to={"/lms"}>
                    <button className="know-more">KNOW MORE</button>
                  </Link>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="figs">
                  <img src={LMS} className="lms1" alt="" />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-6">
                <div className="left alternate">
                  <h5>The Examiner</h5>
                  <p>
                    Well, isn’t that the whole point? To get insights, the
                    examiner portal gives you the ideal data dashboard that
                    visualizes data to provide you with in depth learner
                    analytics that will help you evaluate the gaps in skills and
                    competencies of your work force. This tool will take your
                    training needs analysis to another level!
                  </p>
                  <Link to={"/examiner"}>
                    <button className="know-more">KNOW MORE</button>
                  </Link>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="figs">
                  <img src={EMS} className="lms1" alt="" />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-6">
                <div className="left">
                  <h5>Custom Course Development</h5>
                  <p>
                    Discover personalized learning paths curated to suit your
                    individual needs. Easily acquire new skills efficiently
                    through our intuitive dashboard, which helps you find the
                    most relevant courses and resources aligned with your goals.
                  </p>
                  <Link to={"/custom-course-development"}>
                    <button className="know-more">KNOW MORE</button>
                  </Link>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="figs">
                  <img src={CCD} className="lms1" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <svg
        width="27"
        height="26"
        viewBox="0 0 27 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.83325 7.58334H8.08325M22.1666 7.58334H12.4166"
          stroke="#ffffff"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
        <path
          d="M22.1666 18.4167H18.9166M4.83325 18.4167H14.5833"
          stroke="#ffffff"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
        <path
          d="M4.83325 13H8.08325H22.1666"
          stroke="#ffffff"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
      </svg>
    </>
  );
};

export default Products;
